// Liste des rôles internes (pour déterminer la catégorie par défaut et les options désactivées)
export const INTERNAL_ROLES = [
	"ROLE_ADMIN",
	"ROLE_COM_DIR",
	"ROLE_COM_RES",
	"ROLE_COM",
	"ROLE_COMS",
	"ROLE_ING_DIR",
	"ROLE_ING_RES",
	"ROLE_ING_MANAGER",
	"ROLE_ING_AFF",
	"ROLE_ING_DIAG",
	"ROLE_ING_VERIF",
	"ROLE_ING_EXTRA",
	"ROLE_INGS",
];

export const CATEGORY_OPTIONS = {
	"private-architecte": "Architecte",
	"private-client": "Particulier",
	"pro-property-manager": "Syndic de copropriété",
	"pro-estate-agency": "Agence Immobilière",
	"pro-construction-company": "Entreprise de travaux",
	"intern": "Interne",
	"propect": "Prospect",
	"other": "Autre"
};

export const getCategoryLabel = (key) => {
	return CATEGORY_OPTIONS[key] || key;
};

export const getCategoryKey = (label) => {
	return Object.keys(CATEGORY_OPTIONS).find(key => CATEGORY_OPTIONS[key] === label) || label;
};
